import {
  BusyLevel,
  LocationConfigurationContext,
  //LocationDialog,
} from "@/providers/LocationConfigurationProvider";
//import { useMemo, useState } from "react";
//import { InfoDialog } from "./InfoDialog";
import { useQuery } from "@tanstack/react-query";
import { cn } from "@/lib/utils";
import { InfoIcon } from "lucide-react";
import { API_HOST, menuRoute } from "@/App";
import { useContext } from "react";

export function BusyDialogs(/*{ dialogs }: { dialogs: LocationDialog[] }*/) {
  //const [showDialog, setShowDialog] = useState(false);
  const { locationId } = menuRoute.useParams();
  const { hasBusyIndicator } = useContext(LocationConfigurationContext);

  async function fetchBusyLevel(): Promise<BusyLevel> {
    const response = await fetch(`${API_HOST}/v1/locations/${locationId}/busy`);

    const data = (await response.json()) as {
      status: BusyLevel;
      count: number;
    };

    return data.status;
  }

  const { data: busyLevel } = useQuery<BusyLevel>({
    queryKey: ["busyLevel"],
    queryFn: fetchBusyLevel,
    refetchInterval: 60000, // Refetch every minute
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    retry: 1,
    enabled: hasBusyIndicator,
  });

  if (!hasBusyIndicator) return null;

  /*const dialogToShow = useMemo(() => {
    if (busyLevel === "VERY_HIGH") {
      if (
        sessionStorage.getItem(`dismissed-busy-dialog-${busyLevel}`) !== "true"
      )
        setShowDialog(true);
      return dialogs.find((dialog) => dialog.showOn === "busy-VERY_HIGH");
    }
    if (busyLevel === "HIGH") {
      if (
        sessionStorage.getItem(`dismissed-busy-dialog-${busyLevel}`) !== "true"
      )
        setShowDialog(true);
      return dialogs.find((dialog) => dialog.showOn === "busy-HIGH");
    }
    if (busyLevel === "MEDIUM") {
      if (
        sessionStorage.getItem(`dismissed-busy-dialog-${busyLevel}`) !== "true"
      )
        setShowDialog(true);
      return dialogs.find((dialog) => dialog.showOn === "busy-MEDIUM");
    }

    return null;
  }, [dialogs, busyLevel]);*/

  /*
  function handleClose() {
    sessionStorage.setItem(`dismissed-busy-dialog-${busyLevel}`, "true");
    setShowDialog(false);
  }
  */

  /*if (dialogs.length === 0) {
    return null;
  }*/

  const label = "Currently busy — thanks for your patience!";

  /*const labels: Record<BusyLevel, string> = {
    LOW: "",
    MEDIUM: label,
    HIGH: label, //"Please note: we're currently quite busy, and wont be able to take orders for a while",
    VERY_HIGH: label, // "Please note: we're currently very busy, and wont be able to take orders for a while",
  };*/

  // Note we are only working with the MEDIUM busy level for now
  if (!busyLevel || busyLevel !== "MEDIUM") return null;

  return (
    <section className="max-md:contents mb-8">
      <div
        className={cn(
          //busyLevel === "LOW" && "bg-primary text-primary-foreground",
          busyLevel !== undefined && "bg-yellow-400 text-black",
          //busyLevel === "HIGH" && "bg-red-400 text-white",
          //busyLevel === "VERY_HIGH" && "bg-red-600 text-white",
          "w-full p-2 text-xs md:text-sm transition md:fixed md:top-0 md:left-0 flex items-center gap-2"
        )}
      >
        <InfoIcon size={12} />
        <span>{label}</span>
        {/* 
        {dialogToShow && (
          <InfoDialog
            {...dialogToShow}
            onClose={handleClose}
            show={showDialog}
            onConfirm={handleClose}
          />
        )}
        */}
      </div>
    </section>
  );
}
